import { createPageUrl } from './appRoutes';

const absoluteUrl = (origin: string, path: string): string =>
  new URL(path, origin).toString();

export const createProductShareUrl = (
  origin: string,
  productId: string,
  title: string
): string => absoluteUrl(
  origin,
  createPageUrl('productDetail', { id: productId, title })
);

export const createUserShareUrl = (
  origin: string,
  userId: string,
  publicName: string
): string => absoluteUrl(
  origin,
  createPageUrl('userDetails', { id: userId, name: publicName })
);
